import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { STACK_CENTER_COLUMN_DIRECTION, STACK_CENTER } from '../../constants/mui-components';
import { containerStack, videosStack, videosContainer } from './styles/corporative-videos.styles';
import corporativeVideosData from '../../constants/team/corporative-videos';
import VideoCard from '../../components/cards/VideoCard';

function CorporativeVideoComponent() {
  const theme = useTheme();
  const firstVideo = corporativeVideosData.videos[0];
  const secondVideosArray = corporativeVideosData.videos.slice(1);
  return (
    <Stack className={STACK_CENTER_COLUMN_DIRECTION} sx={containerStack}>
      <Stack className={STACK_CENTER_COLUMN_DIRECTION} gap="1rem">
        <Typography variant="xlarge_3" color={theme.palette.common.white} sx={{ textAlign: 'center' }}>
          {corporativeVideosData.title}
        </Typography>
        <Typography variant="medium_1" color={theme.palette.neutral.A300} sx={{ textAlign: 'center' }}>
          {corporativeVideosData.description}
        </Typography>
      </Stack>
      <Stack className={STACK_CENTER_COLUMN_DIRECTION} sx={videosContainer}>
        <VideoCard video={firstVideo} />
        <Stack className={STACK_CENTER} sx={videosStack}>
          {secondVideosArray.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
}

export default CorporativeVideoComponent;
